function SessionStorage() {
    this.getSessionStorage = function (key) {
        var data = sessionStorage.getItem(key);
        try {
            return JSON.parse(data);
        } catch {
            return data;
        }
    };

    this.setSessionStorage = function (key, data) {
        const stringified = typeof data === 'string' ? data : JSON.stringify(data);
        sessionStorage.setItem(key, stringified);
    };
}

var sesh = new SessionStorage();
module.exports = sesh;
